import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ADMINS_ADMIN_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/admins',
        name: '::Menu:Admins',
        parentName: '::Menu:UserManagement',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Admins',
        order:1
      },
    ]);
  };
}
